import styled from 'styled-components'
import { breakpoints } from '../../utils'

export const StyledContentContainer = styled.div`
  @media (max-width: ${breakpoints[4]}px) {
    padding-top: ${({ styles, isNavMenuPresent }) => styles && (isNavMenuPresent ? styles.mobilePaddingTop : styles.mobileNoNavPaddingTop)}px;
    margin-top: -${({ styles, isNavMenuPresent }) => styles && (isNavMenuPresent ? styles.mobilePaddingTop : styles.mobileNoNavPaddingTop)}px;
  }
  @media (min-width: ${breakpoints[4] + 1}px) {
    padding-top:  ${({ styles, isNavMenuPresent }) => styles && (isNavMenuPresent ? styles.desktopPaddingTop : styles.desktopNoNavPaddingTop)}px;
    margin-top:  -${({ styles, isNavMenuPresent }) => styles && (isNavMenuPresent ? styles.desktopPaddingTop : styles.desktopNoNavPaddingTop)}px;
  }
`
